import isPlainObject from 'lodash.isplainobject';

import { Operator } from '@wf/components';

import { Status } from '../../License/types/enums';

import { type IRestriction, type LicenseTypeNature, type RestrictionValueType } from '../../../types';
import { dateRangeFieldOperators } from '../../../constants';
import { Operators } from '../../../@types/serviceTypes';

import { formatDate } from '../../../helpers/dateHelpers';
import { SearchSelectField } from '../configs';

function generateBackendRestriction(field: string, value?: RestrictionValueType, operator?: string) {
  if (typeof value === 'object' && 'operator' in value) {
    const dateFormat = `yyyy-MM-dd${field === SearchSelectField.lastOperationDate ? ' HH:mm' : ''}`;
    const { startDate, endDate, date, operator } = value;

    if (operator === Operator.dateRange) {
      return {
        field,
        operator: dateRangeFieldOperators[operator as Operator],
        value: formatDate(startDate, dateFormat),
        valueTo: formatDate(endDate, dateFormat),
      };
    } else if (operator === Operator.exactDate && date) {
      const endDate = new Date(date).setDate(date.getDate() + 1);

      return {
        field,
        operator: dateRangeFieldOperators[Operator.dateRange],
        value: formatDate(date, dateFormat),
        valueTo: formatDate(endDate, dateFormat),
      };
    } else {
      return {
        field,
        operator: dateRangeFieldOperators[operator as Operator],
        value: formatDate(date, dateFormat),
      };
    }
  } else if (isPlainObject(value)) {
    return {
      field,
      operator,
      value: (value as SelectOption).value,
    };
  } else {
    return { field, operator, value };
  }
}

export const convertRestrictions = (
  restrictions: Record<string, IRestriction>,
  excludedStatuses: Status[],
  licenseTypeNature?: LicenseTypeNature
) => {
  const backendRestrictions: IRestriction[] = Object.values(restrictions).map(({ field, value, operator }) =>
    generateBackendRestriction(field, value, operator)
  );

  backendRestrictions.push({
    field: 'status',
    values: excludedStatuses.concat([Status.DELETED, Status.GENERATED]),
    operator: Operators.NOT_IN,
  });

  if (licenseTypeNature) {
    backendRestrictions.push({
      field: 'licenseTypeNature',
      value: licenseTypeNature,
      operator: Operators.EQUALS,
    });
  }

  return backendRestrictions;
};
